// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"12":"11407e95","90":"f567f651","615":"2aa375aa","789":"d00f7144","791":"f567f651","912":"b846f583","930":"edefb065"}[chunkId] + ".chunk.css";
};